import { makeAutoObservable } from "mobx";
import { t, translate } from "../../I18n";
import { CheckboxFieldController, ErrorBox } from "../../form";
export class AgeVerificationFormController {
    constructor(service) {
        this.service = service;
        this.checkbox = new CheckboxFieldController({
            initialValue: service.isChecked,
            onUpdate: (value) => {
                this.service.isChecked = value;
            },
            errorBox: new ErrorBox({
                domainObjects: [service],
                errorMessages: {
                    AgeVerificationRequired: translate(t.orders.checkout.age_verification.error),
                },
            }),
        });
        makeAutoObservable(this);
    }
    get fields() {
        return { ageVerification: this.checkbox };
    }
    get fieldsArray() {
        return [this.checkbox];
    }
    get isDirty() {
        return this.fieldsArray.some((f) => f.isDirty);
    }
    get isTouched() {
        return this.fieldsArray.some((f) => f.isTouched);
    }
    get isInvalid() {
        return (this.fieldsArray.some((f) => f.isInvalid) ||
            this.service.availability.isAvailable.isDefinitelyFalse);
    }
    get isValid() {
        return !this.isInvalid;
    }
    get isVisible() {
        return this.service.isRequired;
    }
    get domain() {
        return this.service;
    }
    submit() {
        this.fieldsArray.forEach((f) => f.blur());
    }
}
